export default __webpack_public_path__ + "static/media/banner-alt.2aa53a6c.png";